module.exports = __webpack_public_path__ + "static/media/fraud-banner-desktop.298d9173.png";